import { graphql } from '~/gql'

export default graphql(`
  query GetSalesforceAuthorizationUrl($redirectUrl: String!) {
    Salesforce(redirectUrl: $redirectUrl) {
      authorizationUrl
    }
  }
`)
